module.exports = __webpack_public_path__ + "img/image(3)-2.eb574d84.png";